export default __webpack_public_path__ + "static/media/bb.7a384604.svg";